export { AceEditorDirective } from './src/directive';
export { AceEditorComponent } from './src/component';
export { AceEditorModule } from './src/module';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ng2-ace-editor/index.js
// module id = ./node_modules/ng2-ace-editor/index.js
// module chunks = vendor